// extracted by mini-css-extract-plugin
export default {"threedotsBtn":"style_threedotsBtn__fd3zM","mainCard":"style_mainCard__7SIOD","mainContainer":"style_mainContainer__iwnyW","alertContainer":"style_alertContainer__WgLkj"};